const transportServiceConfig =  require('./transportservice-config');

module.exports = transportServiceConfig;